import React from 'react';
import styles from '@/assets/styles/PrivacyPolicy.module.less';
import { INFO } from '@/utils/constant/info';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className={styles.privacyContainer}>
      <div className={styles.contentWrapper}>
        {/* 标题区域 */}
        <div className={styles.titleSection}>
          <h1>隐私声明</h1>
          <div className={styles.dateInfo}>
            <p>
              <strong>更新日期：</strong>
              {INFO.updateDate}
            </p>
            <p>
              <strong>生效日期：</strong>
              {INFO.effectiveDate}
            </p>
          </div>
        </div>

        {/* 主要内容 */}
        <div className={styles.mainContent}>
          {/* 介绍文本 */}
          <div className={styles.introText}>
            FuriFlow（胡哩胡唠）是一个专注于日语学习的在线应用平台。本隐私声明说明了我们如何收集、使用、存储和保护您的个人信息。
            我们非常重视您的隐私权，并致力于保护您的个人信息安全。
          </div>

          <h2 className={styles.sectionTitle}>1. 我们收集的信息</h2>

          <h3 className={styles.subsectionTitle}>1.1 账户信息</h3>
          <p className={styles.contentText}>当您注册FuriFlow账户时，我们收集以下信息：</p>
          <ul className={styles.infoList}>
            <li>
              <strong>必需信息：</strong>用户名、邮箱地址、密码
            </li>
            <li>
              <strong>可选信息：</strong>电话号码、头像、个人简介
            </li>
          </ul>
          <p className={styles.contentText}>
            这些信息用于创建和管理您的账户，提供个性化服务，并确保账户安全。
          </p>

          <h3 className={styles.subsectionTitle}>1.2 学习数据</h3>
          <p className={styles.contentText}>在您使用FuriFlow学习功能时，我们收集：</p>
          <ul className={styles.infoList}>
            <li>
              <strong>文本分析记录：</strong>您提交的日语文本及分析结果
            </li>
            <li>
              <strong>词典查询记录：</strong>您搜索的词汇及查询历史
            </li>
            <li>
              <strong>词汇学习记录：</strong>生词本内容、学习进度、笔记等
            </li>
            <li>
              <strong>学习偏好：</strong>您的学习设置和偏好配置
            </li>
          </ul>
          <p className={styles.contentText}>
            这些数据用于提供个性化学习体验，改进服务质量，并帮助您跟踪学习进度。
          </p>

          <h3 className={styles.subsectionTitle}>1.3 技术信息</h3>
          <p className={styles.contentText}>为了提供稳定的服务，我们收集：</p>
          <ul className={styles.infoList}>
            <li>
              <strong>设备信息：</strong>浏览器类型、操作系统、设备型号
            </li>
            <li>
              <strong>访问日志：</strong>IP地址、访问时间、页面访问记录
            </li>
            <li>
              <strong>性能数据：</strong>服务响应时间、错误日志等
            </li>
          </ul>
          <p className={styles.contentText}>这些信息用于系统维护、故障排除和服务优化。</p>

          <h2 className={styles.sectionTitle}>2. 信息的使用</h2>

          <h3 className={styles.subsectionTitle}>2.1 核心功能</h3>
          <ul className={styles.infoList}>
            <li>
              <strong>文本分析：</strong>为日语文本提供假名标注、词汇分析等功能
            </li>
            <li>
              <strong>词典查询：</strong>提供词汇释义、例句、发音等信息
            </li>
            <li>
              <strong>学习管理：</strong>管理您的生词本、学习进度和笔记
            </li>
            <li>
              <strong>个性化推荐：</strong>根据您的学习历史推荐相关内容
            </li>
          </ul>

          <h3 className={styles.subsectionTitle}>2.2 服务改进</h3>
          <ul className={styles.infoList}>
            <li>分析用户使用模式，优化产品功能</li>
            <li>改进文本分析算法的准确性</li>
            <li>扩展词典内容和释义质量</li>
            <li>修复系统错误和提升性能</li>
          </ul>

          <h2 className={styles.sectionTitle}>3. 信息的存储与安全</h2>

          <h3 className={styles.subsectionTitle}>3.1 数据存储</h3>
          <p className={styles.contentText}>
            您的个人信息存储在安全的数据库中，我们采用以下措施保护数据安全：
          </p>
          <ul className={styles.infoList}>
            <li>
              <strong>加密存储：</strong>敏感信息（如密码）采用加密算法保护
            </li>
            <li>
              <strong>访问控制：</strong>严格限制数据访问权限
            </li>
            <li>
              <strong>定期备份：</strong>定期备份数据以防数据丢失
            </li>
            <li>
              <strong>安全监控：</strong>实时监控异常访问行为
            </li>
          </ul>

          <h3 className={styles.subsectionTitle}>3.2 数据保留</h3>
          <ul className={styles.infoList}>
            <li>
              <strong>账户信息：</strong>在您的账户存在期间持续保留
            </li>
            <li>
              <strong>学习记录：</strong>在您删除前持续保留，以维护学习连续性
            </li>
            <li>
              <strong>日志数据：</strong>通常保留30天，用于故障排除和安全监控
            </li>
          </ul>

          <h2 className={styles.sectionTitle}>4. 信息的共享与披露</h2>

          <p className={styles.contentText}>
            我们不会向第三方出售、出租或泄露您的个人信息。在以下情况下，我们可能会共享或披露您的信息：
          </p>
          <ul className={styles.infoList}>
            <li>
              <strong>法律要求：</strong>根据法律法规要求或政府部门要求
            </li>
            <li>
              <strong>安全需要：</strong>为了保护用户和公众的安全
            </li>
            <li>
              <strong>服务提供：</strong>与技术服务提供商共享必要的技术数据
            </li>
            <li>
              <strong>用户同意：</strong>获得您明确同意的情况下
            </li>
          </ul>

          <h2 className={styles.sectionTitle}>5. 您的权利</h2>

          <p className={styles.contentText}>您对自己的个人信息享有以下权利：</p>
          <ul className={styles.infoList}>
            <li>
              <strong>访问权：</strong>查看您的个人信息和学习数据
            </li>
            <li>
              <strong>更正权：</strong>更新或修正您的个人信息
            </li>
            <li>
              <strong>删除权：</strong>删除您的个人信息或学习记录
            </li>
            <li>
              <strong>导出权：</strong>导出您的学习数据
            </li>
            <li>
              <strong>注销权：</strong>注销您的账户
            </li>
          </ul>

          <p className={styles.contentText}>您可以通过以下方式行使这些权利：</p>
          <ul className={styles.infoList}>
            <li>登录您的账户，在&quot;我的页面&quot;中管理个人信息</li>
            <li>在&quot;设置&quot;中调整隐私偏好</li>
            <li>联系我们的客户服务</li>
          </ul>

          <h2 className={styles.sectionTitle}>6. 第三方服务</h2>

          <p className={styles.contentText}>FuriFlow使用以下第三方服务来提供更好的用户体验：</p>
          <ul className={styles.infoList}>
            <li>
              <strong>缓存服务：</strong>使用Redis缓存提高响应速度
            </li>
            <li>
              <strong>CDN服务：</strong>使用内容分发网络提高加载速度
            </li>
            <li>
              <strong>分析工具：</strong>使用匿名分析工具了解用户使用情况
            </li>
          </ul>
          <p className={styles.contentText}>
            这些第三方服务提供商都有相应的隐私政策，我们会要求他们按照相关法律法规保护您的信息。
          </p>

          <h2 className={styles.sectionTitle}>7. 未成年人保护</h2>

          <p className={styles.contentText}>
            我们非常重视未成年人的隐私保护。如果您是18岁以下的未成年人，在使用FuriFlow之前，
            请确保获得您的监护人的同意。如果您是14岁以下的儿童，必须在监护人的指导下使用我们的服务。
          </p>

          <h2 className={styles.sectionTitle}>8. 隐私声明的更新</h2>

          <p className={styles.contentText}>
            我们可能会不时更新本隐私声明。当发生重大变更时，我们会通过网站公告、邮件通知或其他适当方式告知您。
            请定期查看本页面以了解最新的隐私政策。
          </p>

          {/* 联系我们区域 */}
          <div className={styles.contactSection}>
            <h2>9. 联系我们</h2>
            <p>如果您对本隐私声明有任何疑问或需要帮助，请通过以下方式联系我们：</p>
            <ul>
              <li>
                <strong>邮箱：</strong>
                {INFO.contact.email}
              </li>
              <li>
                <strong>网站：</strong>
                {INFO.contact.website}
              </li>
              <li>
                <strong>地址：</strong>
                {INFO.contact.address}
              </li>
            </ul>
          </div>

          {/* 法律适用区域 */}
          <div className={styles.legalSection}>
            <h2>10. 法律适用</h2>
            <p>
              本隐私声明的解释和执行适用中华人民共和国相关法律法规。
              如发生争议，双方应友好协商解决；协商不成的，可向有管辖权的人民法院提起诉讼。
            </p>
          </div>

          {/* 重要提示 */}
          <div className={styles.highlightBox}>
            <h3>重要提示</h3>
            <p>
              本隐私声明仅适用于FuriFlow平台。当您点击链接访问其他网站或使用其他服务时，
              请注意这些网站或服务可能有自己的隐私政策。我们建议您在使用任何第三方服务前，
              仔细阅读其隐私政策。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
